module.exports = '<svg width="38" height="32" viewBox="0 0 38 32"><path d="M36.8 12.8H11.251l7.494-7.744a1.673 1.673 0 0 0 0-2.291L16.556.471a1.504 1.504 0 0 0-2.189 0L.447 14.893a1.683 1.683 0 0 0 0 2.294l13.83 14.333a1.493 1.493 0 0 0 2.189 0l2.189-2.291a1.669 1.669 0 0 0 0-2.288L11.164 19.2h25.635a1.6 1.6 0 0 0 1.6-1.6v-3.2a1.6 1.6 0 0 0-1.6-1.6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-4.js
// module id = 1215
// module chunks = 14